import AWN from 'awesome-notifications';
import 'awesome-notifications/dist/style.css';

export const notifier = new AWN({});
